export default __webpack_public_path__ + "static/media/food.8f8ca906.jpg";